/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSquareMinus: {
  name: 'square-minus';
  data: string;
} = {
  name: 'square-minus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm0 2h14v14H5V5Zm4 6a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H9Z" fill="currentColor"/></svg>`,
};
